const selectors = {
  ACTIVE_CONTEXT: ".poems-show__poem-component--active-context",
  ACTIVE_CONTEXT_NOTE: ".poem-component__active-context--note",
  AI_TEXT_TOGGLE: ".ai-text-toggle",
  BANNER_PROMO: ".banner-promo",
  COMPONENT: ".poems-show__poem-component",
  COMPONENT_ITEM: ".poems-show__poem-component-item",
  COMPONENT_ITEMS: ".poems-show__poem-component-items",
  COMPONENT_ITEMS_SELECT: ".poem-component-items__select",
  COMPONENT_ITEMS_SELECT_OPTION: ".poem-component-items__select--option",
  COMPONENT_TITLE: ".poems-show__poem-component--title",
  COMPONENT_VALUE: ".poems-show__poem-component--value",
  COMPONENT_VALUE_REPLACE: ".poems-show__poem-component--value-replace",
  COMPONENTS: ".poems-show__poem-components",
  CONTAINER: "#poems-show__container",
  CONTEXT_SWITCHER: ".poem-context-switcher",
  DRAWER: "#poems-show__drawer",
  DRAWER_CONTENT: "#poems-show__drawer--content",
  DRAWER_TITLE: "#poems-show__drawer--title",
  FOOTER: "section.footer",
  GUIDE_COLUMN: "#poems-show__guide--column",
  HOD_PROMO: ".hod-promo",
  HOD_PROMO_CTA: ".hod-promo__cta",
  INLINE_LINK: ".poem-inline__link",
  IS_FOCUSED: ".is-focused",
  LC_TEXT_TOGGLE: ".lc-text-toggle",
  LINE_MAP_CONTENT_ONE_TO_ONE: ".poem-inline__lm--content-one-to-one",
  LINE_MAP_CONTENT_STRUCTURE: ".poem-inline__lm--content-structure",
  LINE_MAP_VALUE_ONE_TO_ONE: ".poem-inline__lm--value-one-to-one",
  LINE_MAP_VALUE_RHYME_SCHEME: ".poem-inline__lm--value-rhyme-scheme",
  LINE_MAP_VALUE_STRUCTURE: ".poem-inline__lm--value-structure",
  LINE_MAPS:
    ".poem-inline__lm--content-highlight, .poem-inline__lm--content-one-to-one, .poem-inline__lm--value-one-to-one, .poem-inline__lm--value-structure, .poem-inline__lm--content-rhyme-scheme, .poem-inline__lm--value-rhyme-scheme, .poem-inline__lm--structure-line", // eslint-disable-line max-len
  MAIN: "#poems-show",
  MAIN_CONTENT: "#poems-show__main-content",
  MOBILE_HEADER: "#poems-show__mobile-header",
  MOBILE_HEADER_MAIN: "#poems-show__mobile-header--main",
  MOBILE_NAV: "#poems__mobile-nav",
  MOBILE_NAV_LINK: ".poems__mobile-nav--link",
  MOBILE_NAV_TOGGLE: "#poems__mobile-nav--toggle",
  MODAL_LIT_TERM: "#poems-show__lit-term-modal",
  MODAL_LIT_TERM_DEFINITION: "#poems-show__lit-term-modal--definition",
  MODAL_LIT_TERM_LINK: "#poems-show__lit-term-modal--link",
  MODAL_LIT_TERM_TITLE: "#poems-show__lit-term-modal--title",
  NAV: "#poems__nav",
  NAV_LINK: ".poems__nav--link",
  PDF_HEADER: "#poems-show__pdf-header",
  POEM_AI_TOOL: ".poem-ai-tool",
  POEM_CONTENT: ".poems-show__poem-content",
  POEM_GUIDE_CONTENT: ".poem-guide-content",
  PROMO: ".poems-show__promo",
  PROMO_ALT: ".poems-show__promo--alt",
  PROMO_MAIN: ".poems-show__promo--main",
  SECTION: ".poems-show__poem-component-section",
  SECTION_INSTRUCTIONS: ".poems-show__poem-component--instructions",
  SECTION_TITLE: ".poems-show__poem-component-section--title",
  TEXT_COLUMN: "#poems-show__poem-text--column",
  TEXT_FIXED: "#poems-show__poem-text--fixed",
  TEXT_LINK: ".poems-show__poem-text--link",
  TEXT_MODAL: "#poems-show__poem-text--modal",
  TEXT_MODAL_CATEGORY: ".poem-text-modal__category",
  TEXT_MODAL_TOGGLE: ".poem-text-modal__toggle",
  TEXT_SCROLLABLE: "#poems-show__poem-text--scrollable",
  TEXT_TITLE: ".poems-show__poem-text--title"
};

export default selectors;
